export default "__VITE_ASSET__HZZKvJDg__"